import {Component} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {
  inputPlaceholderStyle,
  placeholderStyles,
} from "@app/shared/constants/placeholder-style";

@Component({
  selector: "app-dashboard-skeleton",
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: "./dashboard-skeleton.component.html",
  styleUrl: "./dashboard-skeleton.component.scss",
})
export class DashboardSkeletonComponent {
  public inputPlaceholderStyle = inputPlaceholderStyle;
  public placeholderStyles = placeholderStyles;
}
